import React from 'react';
import PropTypes from 'prop-types';

import { H1 } from 'components/atoms/Typography';
import { Section, Container } from 'components/atoms/Page';

import Image from 'components/atoms/Image/Image';
import { ReviewBar } from 'components/molecules/ReviewBar/ReviewBar';

import { FacilityAddress } from 'components/facility/FacilityAddress';
import Link from 'components/atoms/Link/Link';

import trustedParter from 'assets/images/logos/trusted-partner.svg';

import './FacilityDetails.scss';

export function FacilityDetails(props) {
	return (
		<Container className="facility-details">
			<Section className="facility-details__section">
				<div className="facility-details__header">
					<Image
						src={trustedParter}
						alt="Trusted Partner"
						className="facility-details__image"
						width={100}
						height={100}
					/>
					<div>
						<H1 className="facility-details__facility-name">
							{props.facility.name}
						</H1>
						<div className="facility-details__facility-address desktop">
							<FacilityAddress
								address={props.facility.location}
								className="facility-details__address"
							/>
							<div className="gray-dot" />
							{!!props.phone && (
								<Link
									href={`tel:${props.phone.number}`}
									className="facility-details__ph-number"
								>
									{props.phone.formattedNumber}
								</Link>
							)}
							{!!props.facility.reviews.number && (
								<div className="gray-dot" />
							)}
							{!!props.facility.reviews.number && (
								<button
									className="facility-details__review-bar"
									onClick={props.scrollToReviews}
								>
									<ReviewBar
										average={props.facility.reviews.average}
										number={props.facility.reviews.number}
									/>
								</button>
							)}
						</div>
					</div>
				</div>
				<div className="facility-details__facility-address mobile">
					<FacilityAddress
						address={props.facility.location}
						className="facility-details__address"
					/>
					<div className="gray-dot" />
					{!!props.phone && (
						<Link
							href={`tel:${props.phone.number}`}
							className="facility-details__ph-number"
						>
							{props.phone.formattedNumber}
						</Link>
					)}
					<div className="gray-dot" />
					{!!props.facility.reviews.number && (
						<button
							className="facility-details__review-bar"
							onClick={props.scrollToReviews}
						>
							<ReviewBar
								average={props.facility.reviews.average}
								number={props.facility.reviews.number}
							/>
						</button>
					)}
				</div>
			</Section>
		</Container>
	);
}

FacilityDetails.propTypes = {
	facility: PropTypes.object.isRequired,
	phone: PropTypes.shape({
		number: PropTypes.string,
		formattedNumber: PropTypes.string,
	}),
	scrollToReviews: PropTypes.func.isRequired,
};
